module.exports = __webpack_public_path__ + "media/landing_work/home/images/front_end-c547bcd1c7205759f10b38586cd2ede8.svg";